import { useReducer, useState } from "react";

const initialState = {
    serviceType: '',
    daycareType: 'Single Day',
    checkInDate: '',
    checkOutDate: '',
    checkInTime: '',
    checkOutTime: '',
    dogsCount: 0,
    catsCount: 0,
    location: '',
};
const services = [
    {
        icon: "📅", 
        name: "Pet Boarding",
        description:
            "Providing exceptional care for your pets at our Pet Boarding Facility, where they discover a Home away from Home equipped with modern amenities tailored for their comfort.",
    },
    {
        icon: "🐕", 
        name: "Pet Hosting",
        description:
            "Your pets enjoy a delightful stay at Pet Hero's warm and inviting home, where they are embraced as part of the family and experience a cozy, home-like atmosphere.",
    },
    {
        icon: "🐾", 
        name: "Pet Sitting",
        description:
            "Your sitter provides dedicated care for your pets in the comfort of your own home, ensuring they receive all the attention they need without having to leave familiar surroundings.",
    },
];
const benefits = [
    {
        icon: "✔️",
        text: "All pet boarders and sitters undergo thorough screening & background check",
    },
    {
        icon: "✔️",
        text: "Every pet boarder and sitter provides a comprehensive profile and personal details",
    },
    {
        icon: "✔️",
        text: "Every pet boarder and sitter is accredited and verified by our team of professionals",
    },
];
const features = [
    {
      icon: "🔍",  
      title: "Search",
      description: "Search and connect with affectionate and trustworthy pet sitters and pet boarders perfectly matched for you and your beloved pets."
    },
    {
      icon: "💵", 
      title: "Book & Pay",
      description: "No need for cash – pet sitters and pet boarders accept your request, and we've made it easy to make secure payments through our website."
    },
    {
      icon: "😌",  
      title: "Relax",
      description: "Your pet enjoys endless fun, and you receive regular photo and video updates. Plus, your booking is supported by 24/7 assistance."
    }
  ];
  const petBoardingDetails = [
    {
      title: "Undivided Attention",
      description: "Each pet sitter & boarding facility is highly experienced in pet care, especially important if your furry friend requires constant supervision or medication.",
      icon: "👀",
    },
    {
      title: "Trusted, Reliable, Local",
      description: "All Adopt a Pet Sitters are background-checked and verified before being listed on our platform, giving you complete peace of mind.",
      icon: "🔒",
    },
    {
      title: "Pet-lovers",
      description: "Our Pet Sitters & Pet Boarding Facility is committed to giving your pet the same level of love and care that they’re used to getting from you.",
      icon: "❤️",
    },
    {
      title: "All Bookings Insured",
      description: "All bookings are covered Adopt a Pet Protection so there are no extra hassles for you to worry about.",
      icon: "🛡️",
    },
    {
      title: "Environment Familiarity",
      description: "When you choose Adopt a Pet for dog boarding service, your furry friend stays in the environment they’re most familiar with, reducing stress and avoiding travel trauma.",
      icon: "🏡",
    },
    {
        title: "Environment Familiarity",
        description: "When you choose Adopt a Pet for dog boarding service, your furry friend stays in the environment they’re most familiar with, reducing stress and avoiding travel trauma.",
        icon: "🏡",
      },
  ];
  const faqData = [
    {
      question: "How does Adopt a Pet vet pet sitters and boarding facilities?",
      answer: "Adopt a Pet thoroughly screens and verifies each pet sitter and boarding facility before listing them on the platform. This includes background checks and reviews from previous clients.",
    },
    {
      question: "What is pet boarding, and how does it work with Adopt a Pet?",
      answer: "Pet boarding is a service where your pet stays in a facility or sitter's home while you're away. Adopt a Pet offers both professional pet boarding services and pet sitters, all available for booking through our platform.",
    },
    {
      question: "What should I bring for my pet's boarding stay?",
      answer: "We recommend bringing your pet’s food, any medications they need, their favorite toys, and bedding. This helps your pet feel comfortable and settled during their stay.",
    },
    {
      question: "How do I choose the right pet sitter or dog sitter on Adopt a Pet?",
      answer: "You can read detailed profiles of pet sitters and boarding facilities, view their ratings and reviews, and even message them before booking. This ensures that you find a sitter that meets your needs and your pet’s requirements.",
    },
    {
      question: "Can you trust Pet Sitters?",
      answer: "Yes, all pet sitters on Adopt a Pet are background-checked and verified to ensure they are trustworthy and reliable. You can also read reviews from other pet owners.",
    },
    {
      question: "Can I meet a potential pet sitter before booking?",
      answer: "Absolutely! You can arrange a meeting with potential pet sitters before booking to ensure you’re comfortable with their services and approach to pet care.",
    },
    {
      question: "How do I book a boarding service on Adopt a Pet?",
      answer: "Booking a boarding service is simple. Search for available pet sitters and boarding facilities, select one that suits your needs, and follow the steps to confirm your booking.",
    },
    {
      question: "What are the payment options available on Adopt a Pet?",
      answer: "We accept all major credit and debit cards, as well as secure online payment methods. Payment is processed directly through the platform.",
    },
    {
      question: "What happens in case of an emergency?",
      answer: "In case of an emergency, Adopt a Pet offers 24/7 customer support to assist you. Our sitters and facilities are trained to handle emergencies and will contact you immediately if necessary.",
    },
    {
      question: "How does Adopt a Pet ensure the safety of my pet during their stay?",
      answer: "We ensure the safety of your pet by working with certified and verified sitters, providing secure booking and payment systems, and offering support for any concerns throughout the booking process.",
    },
    {
      question: "Can Adopt a Pet accommodate special requests for my pet's care?",
      answer: "Yes, many of our sitters and boarding facilities can accommodate special requests such as dietary needs, medication, or extra attention for elderly pets. Be sure to discuss your requirements before booking.",
    },
    {
      question: "How can I contact customer support for pet boarding queries?",
      answer: "You can contact our customer support team via the website or app. We offer live chat, email support, and phone assistance for any queries you may have.",
    },
    {
      question: "What are the average hourly rates for pet sitting?",
      answer: "Hourly rates for pet sitting vary depending on the sitter and location. On average, pet sitters charge between $15 and $30 per hour.",
    },
    {
      question: "Could I arrange a conversation with the dog sitter before finalizing the booking?",
      answer: "Yes, you can message or call the sitter before making a booking. This helps you ensure they’re a good fit for your pet.",
    },
    {
      question: "How do I create a booking for my pet?",
      answer: "To create a booking, simply select a pet sitter or boarding facility, choose the dates and times for your pet’s stay, and confirm your booking through the website or app.",
    },
    {
      question: "Do pet sitters need accident cover?",
      answer: "Yes, it’s important for pet sitters to have accident coverage to ensure they are protected in case of any unforeseen incidents. We recommend sitters have appropriate insurance coverage.",
    },
  ];

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_SERVICE_TYPE':
            return { ...state, serviceType: action.payload };
        case 'SET_DAYCARE_TYPE':
            return { ...state, daycareType: action.payload };
        case 'SET_CHECK_IN_DATE':
            return { ...state, checkInDate: action.payload };
        case 'SET_CHECK_OUT_DATE':
            return { ...state, checkOutDate: action.payload };
        case 'SET_CHECK_IN_TIME':
            return { ...state, checkInTime: action.payload };
        case 'SET_CHECK_OUT_TIME':
            return { ...state, checkOutTime: action.payload };
        case 'INCREMENT_DOGS':
            return { ...state, dogsCount: state.dogsCount + 1 };
        case 'DECREMENT_DOGS':
            return { ...state, dogsCount: Math.max(state.dogsCount - 1, 0) };
        case 'INCREMENT_CATS':
            return { ...state, catsCount: state.catsCount + 1 };
        case 'DECREMENT_CATS':
            return { ...state, catsCount: Math.max(state.catsCount - 1, 0) };
        case 'SET_LOCATION':
            return { ...state, location: action.payload };
        default:
            return state;
    }
};

const PetBoarding = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const handleIncrementDogs = () => dispatch({ type: 'INCREMENT_DOGS' });
    const handleDecrementDogs = () => dispatch({ type: 'DECREMENT_DOGS' });

    const handleIncrementCats = () => dispatch({ type: 'INCREMENT_CATS' });
    const handleDecrementCats = () => dispatch({ type: 'DECREMENT_CATS' });
    const [openIndex, setOpenIndex] = useState(null);

  const toggleAnswer = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


    return (
        <div className="bg-gray-50 ">

            <div

                style={{ backgroundImage: 'url(./how.jpg)', height: "400px" }}
            ></div>

            <div className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-lg mt-[-100px]">
                <h2 className="text-center font-bold text-2xl text-gray-800">Pet Boarding Service</h2>


                <div className="service-type mt-6">
                    <h3 className="text-lg font-semibold text-gray-700">Select Service Type</h3>
                    <div className="md:flex md:space-x-4 md:space-y-0 space-y-2 mt-4">
                        {['Overnight', 'Daycare', 'Pet Boarding', 'Pet Hosting', 'Pet Sitting'].map((service, index) => (
                            <button
                                key={index}
                                className={`border p-3 rounded-lg w-full text-center ${state.serviceType === service ? 'bg-orange-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                                onClick={() => dispatch({ type: 'SET_SERVICE_TYPE', payload: service })}
                            >
                                {service}
                            </button>
                        ))}
                    </div>
                </div>


                {state.serviceType === 'Daycare' && (
                    <div className="daycare-type mt-6">
                        <h3 className="text-lg font-semibold text-gray-700">How often do you need Daycare Service?</h3>
                        <div className="flex space-x-4 mt-4">
                            {['Single Day', 'More than one day'].map((daycareType, index) => (
                                <button
                                    key={index}
                                    className={`border p-3 rounded-lg w-full text-center ${state.daycareType === daycareType ? 'bg-orange-600 text-white' : 'bg-gray-200 text-gray-700'}`}
                                    onClick={() => dispatch({ type: 'SET_DAYCARE_TYPE', payload: daycareType })}
                                >
                                    {daycareType}
                                </button>
                            ))}
                        </div>
                    </div>
                )}


                <div className="dates mt-6">
                    <h3 className="text-lg font-semibold text-gray-700">Enter Check-In and Check-Out Details</h3>
                    <div className="grid grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="text-gray-600">Check-In Date</label>
                            <input
                                type="date"
                                value={state.checkInDate}
                                onChange={(e) => dispatch({ type: 'SET_CHECK_IN_DATE', payload: e.target.value })}
                                className="w-full p-3 border border-gray-300 rounded-lg mt-2"
                            />
                        </div>
                        <div>
                            <label className="text-gray-600">Check-Out Date</label>
                            <input
                                type="date"
                                value={state.checkOutDate}
                                onChange={(e) => dispatch({ type: 'SET_CHECK_OUT_DATE', payload: e.target.value })}
                                className="w-full p-3 border border-gray-300 rounded-lg mt-2"
                            />
                        </div>
                        <div>
                            <label className="text-gray-600">Check-In Time</label>
                            <input
                                type="time"
                                value={state.checkInTime}
                                onChange={(e) => dispatch({ type: 'SET_CHECK_IN_TIME', payload: e.target.value })}
                                className="w-full p-3 border border-gray-300 rounded-lg mt-2"
                            />
                        </div>
                        <div>
                            <label className="text-gray-600">Check-Out Time</label>
                            <input
                                type="time"
                                value={state.checkOutTime}
                                onChange={(e) => dispatch({ type: 'SET_CHECK_OUT_TIME', payload: e.target.value })}
                                className="w-full p-3 border border-gray-300 rounded-lg mt-2"
                            />
                        </div>
                    </div>
                </div>


                <div className="pets-count mt-6">
                    <h3 className="text-lg font-semibold text-gray-700">How many pets are you bringing?</h3>
                    <div className="flex space-x-8 mt-4">
                        <div className="flex items-center space-x-2">
                            <label className="text-gray-600">Dogs</label>
                            <button
                                onClick={handleDecrementDogs}
                                className="border p-2 rounded-full bg-gray-200 text-gray-700"
                            >
                                -
                            </button>
                            <span className="font-bold">{state.dogsCount}</span>
                            <button
                                onClick={handleIncrementDogs}
                                className="border p-2 rounded-full bg-gray-200 text-gray-700"
                            >
                                +
                            </button>
                        </div>
                        <div className="flex items-center space-x-2">
                            <label className="text-gray-600">Cats</label>
                            <button
                                onClick={handleDecrementCats}
                                className="border p-2 rounded-full bg-gray-200 text-gray-700"
                            >
                                -
                            </button>
                            <span className="font-bold">{state.catsCount}</span>
                            <button
                                onClick={handleIncrementCats}
                                className="border p-2 rounded-full bg-gray-200 text-gray-700"
                            >
                                +
                            </button>
                        </div>
                    </div>
                </div>


                <div className="location mt-6">
                    <label className="text-gray-600">Your Location</label>
                    <input
                        type="text"
                        placeholder="Search your locality"
                        value={state.location}
                        onChange={(e) => dispatch({ type: 'SET_LOCATION', payload: e.target.value })}
                        className="w-full p-3 border border-gray-300 rounded-lg mt-2"
                    />
                </div>

                <div className="submit mt-6 text-center">
                    <button className="bg-orange-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-orange-500">
                        Submit
                    </button>
                </div>


            </div>
            <div className="p-6 max-w-3xl mx-auto mt-12">
                <h2 className="text-center font-bold text-3xl text-gray-800 mb-6">Comprehensive Care for every Dog and Cat</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {services.map((service, index) => (
                        <div key={index} className="bg-white shadow-lg rounded-lg p-4">
                            <div className="text-center text-4xl">{service.icon}</div>
                            <h3 className="text-xl font-semibold text-center mt-4">{service.name}</h3>
                            <p className="text-gray-600 text-center mt-2">{service.description}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="p-6 max-w-7xl mx-auto">
      <div className="flex flex-col lg:flex-row items-center space-y-6 lg:space-y-0">
       
        <div className="flex-1">
          <h2 className="text-center font-bold text-3xl text-gray-800 mb-6">
            Book top-notch pet care anytime, anywhere
          </h2>

          <div className="space-y-4 mb-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-center space-x-3">
                <span className="text-green-600 text-2xl">{benefit.icon}</span>
                <p className="text-gray-700 text-lg">{benefit.text}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <button className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold">
              Find and Book a Pet Sitter
            </button>
          </div>
        </div>

        <div className="flex-1">
          <img
            src="//dm6g3jbka53hp.cloudfront.net/static-images/boarding-landing-page__sitter__verification__pet-travel-v1.jpg"
            alt="Pet Boarding"
            className="w-full h-auto rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
    <div className="p-6 max-w-7xl mx-auto">
      <h2 className="text-center font-bold text-3xl text-gray-800 mb-10">
        Discover local pet sitters and pet boarders who'll care for your pets like their own family.
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div key={index} className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300">
            <div className="text-4xl mb-4 text-orange-600">{feature.icon}</div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">{feature.title}</h3>
            <p className="text-gray-700">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
    <div className="p-6 max-w-7xl mx-auto">
      <h2 className="text-center font-bold text-3xl text-gray-800 mb-10">
        Find a trusted Pet boarding service near you
      </h2>
      <p className="text-center text-lg text-gray-700 mb-8">
        Looking for a pet sitter that can keep your pet happy when you are away? You’ve come to the right place! Adopt a Pet for professional pet boarding service and pet sitting services all around India.
      </p>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
        {petBoardingDetails.map((detail, index) => (
          <div key={index} className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300">
            <div className="text-4xl mb-4 text-orange-600">{detail.icon}</div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">{detail.title}</h3>
            <p className="text-gray-700">{detail.description}</p>
          </div>
        ))}
      </div>

      <div className="text-center">
        <p className="text-lg text-gray-700 mb-6">
          Need someone trustworthy to care for your Furry baby? Done. When you choose Adopt a Pet for dog boarding service, your furry friend stays in the environment they’re most familiar with, reducing stress and avoiding travel trauma.
        </p>
        <button className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700">
          Start Search for a 5-Star Pet Boarding Service Near You
        </button>
      </div>

     
      <div className="mt-12 text-center">
        <img
          src="//dm6g3jbka53hp.cloudfront.net/static-images/boarding-landing-page__usps.jpg"
          alt="Pet Boarding"
          className="mx-auto rounded-lg shadow-lg"
        />
      </div>
    </div>
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-center font-bold text-3xl text-gray-800 mb-8">
        Frequently Asked Questions
      </h2>

      <div className="space-y-4">
        {faqData.map((faq, index) => (
          <div key={index} className="bg-white shadow-lg rounded-lg p-4">
            <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleAnswer(index)}>
              <h3 className="text-xl font-semibold text-gray-800">{faq.question}</h3>
              <span className="text-xl ml text-gray-600">
                {openIndex === index ? "-" : "+"}
              </span>
            </div>

            {openIndex === index && <p className="mt-2 text-gray-700">{faq.answer}</p>}
          </div>
        ))}
      </div>
    </div>
        </div>
    );
};

export default PetBoarding;
